import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl, setFormData, setFormDataV2 } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class LevelOfServiceService {

  constructor(private http: HttpClient) { }

  getVehicles(isAdmin, queryParams) {
    const params = new HttpParams({fromObject: queryParams});
    return this.http.get<any>(urls.BASE_URL + (isAdmin ? urls.LEVEL_OF_SERVICE:urls.TP_LEVEL_OF_SERVICE) , { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  saveVehicle(isAdmin, vehicleId, payload) {
    const formData = setFormDataV2(payload, 'vehicle');

    if (vehicleId) {
      // Edit
      return this.http.put<any>(urls.BASE_URL + (isAdmin ? urls.LEVEL_OF_SERVICE:urls.TP_LEVEL_OF_SERVICE)  +`/${vehicleId}`, formData)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      // Add
      return this.http.post<any>(urls.BASE_URL + (isAdmin ? urls.LEVEL_OF_SERVICE:urls.TP_LEVEL_OF_SERVICE) , formData)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getVehicleById(isAdmin, vehicleId) {
    return this.http.get<any>(urls.BASE_URL +  (isAdmin ? urls.LEVEL_OF_SERVICE:urls.TP_LEVEL_OF_SERVICE) + `/${vehicleId}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  getLevelOfServicebyId(id) {
    return this.http.get<any>(urls.BASE_URL  + urls.LEVEL_OF_SERVICE_URL + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }


  saveLevelOfService(id, payload) {

    if (id) {
      // Edit
      return this.http.put<any>(urls.BASE_URL+ urls.LEVEL_OF_SERVICE_URL + `/${id}`, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      // Add
      return this.http.post<any>(urls.BASE_URL + urls.LEVEL_OF_SERVICE_URL , payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getLevelOfServices(queryParams) {
    const params = new HttpParams({fromObject: queryParams});
    const headers = new HttpHeaders({
      'Authorization':'providerToken'
    });

    return this.http.get<any>(urls.BASE_URL + urls.LEVEL_OF_SERVICE_URL  , { params, headers })
      .pipe(
        catchError(errorHandl)
      );
  }

  getServiceTypebyId(id) {
    return this.http.get<any>(urls.BASE_URL  + urls.SPACE_TYPE_URL + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }


  saveServiceType(id, payload) {

    if (id) {
      // Edit
      return this.http.put<any>(urls.BASE_URL+ urls.SPACE_TYPE_URL + `/${id}`, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      // Add
      return this.http.post<any>(urls.BASE_URL + urls.SPACE_TYPE_URL , payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getSpaceTypes(queryParams) {
    const params = new HttpParams({fromObject: queryParams});
    const headers = new HttpHeaders({
      'Authorization':'providerToken'
    });
    return this.http.get<any>(urls.BASE_URL + urls.SPACE_TYPE_URL  , { params, headers })
      .pipe(
        catchError(errorHandl)
      );
  }
}
